import { jsx as r } from "react/jsx-runtime";
const l = ({
  size: t
}) => {
  switch (t) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M4.03752 12.6683L3.33502 11.9658L10.9659 4.33496H6.33502V3.33496H12.6684V9.66829H11.6684V5.03746L4.03752 12.6683Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M6.05375 19L5 17.9462L16.4462 6.5H9.5V5H19V14.5H17.5V7.55375L6.05375 19Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M5.04646 15.8317L4.16833 14.9536L13.7069 5.41504H7.91833V4.16504H15.835V12.0817H14.585V6.29316L5.04646 15.8317Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: t
}) => {
  switch (t) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M3.93083 13.1291L2.87 12.0683L10.5515 4.38678H6.279V2.87012H13.129V9.72012H11.6123V5.44762L3.93083 13.1291Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M5.89899 19.6934L4.30774 18.1022L15.83 6.57993H9.42124V4.30493H19.6962V14.5799H17.4212V8.17118L5.89899 19.6934Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M4.91509 16.4138L3.58905 15.0878L13.1909 5.48592H7.8503V3.59009H16.4128V12.1526H14.517V6.81196L4.91509 16.4138Z",
          fill: "currentColor"
        }
      );
  }
}, a = ({
  size: t = "md",
  weight: e = "default"
}) => {
  switch (e) {
    case "bold":
      return /* @__PURE__ */ r(o, { size: t });
    case "book":
    case "default":
      return /* @__PURE__ */ r(l, { size: t });
  }
};
export {
  a as default
};
//# sourceMappingURL=DIconExternalLink.js.map
